<template>
    <div class="dialog-del-custom">
        <DialogCustom
            :visible.sync="visible"
            v-bind="$attrs"
            :title="title"
            :buttons="buttons"
            @confirm="handlerConfirm"
            @cancel="visible = false"
        >
            <div class="label">
                <!-- <img :src="icon"> -->
                {{ label }}
            </div>
        </DialogCustom>
    </div>
</template>

<script>
import DialogCustom from "@/components/DialogCustom";
import icon from "./icon.png";
/**
 *弹窗删除组件
 *@author zhouyingchao
 */
export default {
  name:"DialogDelCustom",
  components: {
    DialogCustom
  },
  inheritAttrs: false,
  props: {
    value:{
      type:Boolean,
      default:false
    },
    label:{
      type:String,
      default: "确认要删除吗？"
    },
    title:{
      type:String,
      default: "删除"
    },
    buttons: {
      type: Object,
      default: () => ({
        cancel: {
          text: "取消",
        },
        confirm: {
          text: "确定删除",
        },
      }),
    },
  },
  data() {
    return {
      icon,
      visible:false,
    };
  },
  watch:{
    value:{
      handler(val,old) {
        if (val !== old) {
          this.visible = val;
        }

      },
      immediate:true
    },
    visible:{
      handler(val,old) {
        if (val !== old) {
          this.$emit("input", val);
        }
      },
      immediate:true
    }
  },

  methods: {
    async handlerConfirm() {
      try {
        if (this.$listeners.confirm) {
          await this.$listeners.confirm(); // $listeners.confirm 须返回Promise
        }

        await this.$nextTick();

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }

    }
  }
};
</script>
<style lang="scss" scoped>
    .dialog-del-custom{
        .label{
            font-size:14px;
            color:rgba(96,98,102,1);
            display: flex;
            flex-direction: row;
            >img{
                flex-shrink: 0;
                width: 24px;
                height: 24px;
                margin-right: 8px;
                margin-top: -2px;
            }
        }
    }
</style>
